module.exports = __webpack_public_path__ + "img/bnr-today@2x.811c7d52.jpg";